
import { html } from "lit";
import { QuickActionsMenu } from "./quick-actions-menu";

export const template = (props: QuickActionsMenu) => html`
<span >
  <slot name="anchor"></slot>
  <slot name="content"></slot>
</span>
`;
